import script from "./footer.vue?vue&type=script&setup=true&lang=js"
export * from "./footer.vue?vue&type=script&setup=true&lang=js"

import "./footer.vue?vue&type=style&index=0&id=6cdba5a2&scoped=true&lang=css"

import exportComponent from "D:\\work\\gw-jw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cdba5a2"]])

export default __exports__